import { types } from '../../../constants/ActionTypes'

const initialState = {
  open: false,
}

const userListDialog = (state = initialState, action) => {
  switch (action.type) {
    case types.userListDialog.OPEN:
      return { open: true }
    case types.userListDialog.CLOSE:
      return { open: false }
    default:
      return state
  }
}

export default userListDialog



// WEBPACK FOOTER //
// ./src/reducers/Common/Chat/UserListDialog.js